"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web_ui_1 = require("@gibme/web-ui");
const api_1 = __importDefault(require("../api"));
const add_client_modal_1 = __importDefault(require("../modals/add_client_modal"));
const edit_client_modal_1 = __importDefault(require("../modals/edit_client_modal"));
(0, web_ui_1.$)(document).ready(() => {
    const card = (0, web_ui_1.$)('#staff-portal-card');
    const table = (0, web_ui_1.createDataTable)('#client_info_list')
        .draw()
        .columns.adjust()
        .responsive.recalc();
    const cache = new Map();
    window.handle_client_edit = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const record = cache.get(id);
        if (!record) {
            return;
        }
        (0, edit_client_modal_1.default)(record);
    });
    card.on('refresh', () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            web_ui_1.LoadingOverlay.show();
            const records = yield api_1.default.listClients();
            table.clear();
            cache.clear();
            for (const record of records) {
                table.row.add([
                    record.last_name,
                    record.first_name,
                    record.mobile || '',
                    record.birthday,
                    record
                ]);
                cache.set(record.id, record);
            }
        }
        finally {
            table.draw()
                .columns.adjust()
                .responsive.recalc();
            web_ui_1.LoadingOverlay.hide();
        }
    }));
    (0, web_ui_1.$)('#add_client_button').on('click', () => {
        (0, add_client_modal_1.default)();
    });
});
